import React from "react";
import {useRecoilState, useRecoilValue} from "recoil";
import tabState from "../state/ui/activeTabState";
import activeModalState from "../state/ui/activeModalState";
import { useTranslation } from "react-i18next";
import reviveModeState from "../state/ui/reviveModeState";
import boothModeState from "../state/ui/boothModeState";

export default function BottomBar () {

    const {t} = useTranslation('lounge')

    const [activeTab, setShowTab] = useRecoilState(tabState);
    const [activeModal, setShowModal] = useRecoilState(activeModalState);
    const reviveMode = useRecoilValue(reviveModeState);
    const boothMode = useRecoilValue(boothModeState);

    return (
      <div className="tab-bar">
          <div className="tab-bar-container">
              <button onClick={() => {setShowTab(0); setShowModal('');}} className={`${activeTab === 0 ? 'selected':''}`}>
                  <div className="tab-bar-item">
                      <img
                        className="tab-bar-icon"
                        draggable="false"
                        src="/images/space/icon-lounge.png"
                      />
                  </div>
                  <p className={`text-xs ${activeTab === 0 ? 'text-white':'text-gray-400'}`}>{t('space')}</p>
              </button>
              <button onClick={() => {setShowTab(1); setShowModal('');}} className={`${activeTab === 1 ? 'selected':''} ${reviveMode ? 'hidden':''}`}>
                  <div className="tab-bar-item">
                      <img
                        className="tab-bar-icon"
                        draggable="false"
                        src="/images/space/icon-people.png"
                      />
                  </div>
                  <p className={`text-xs ${activeTab === 1 ? 'text-white':'text-gray-400'}`}>{t('people')}</p>
              </button>
              <button onClick={() => {setShowTab(2); setShowModal('');}} className={`${activeTab === 2 ? 'selected':''} ${reviveMode ? 'hidden':''}`}>
                  <div className="tab-bar-item">
                      <img
                        className="tab-bar-icon"
                        draggable="false"
                        src="/images/space/icon-chat.png"
                      />
                  </div>
                  <p className={`text-xs ${activeTab === 2 ? 'text-white':'text-gray-400'}`}>{t('chat')}</p>
              </button>
              <button onClick={() =>{ setShowTab(3); setShowModal('video-setting'); }} className={`${activeTab === 3 ? 'selected':''}`}>
                  <div className="tab-bar-item">
                      <img
                        className="tab-bar-icon"
                        draggable="false"
                        src="/images/space/icon-setting.png"
                      />
                  </div>
                  <p className={`text-xs ${activeTab === 3 ? 'text-white':'text-gray-400'}`}>{t('settings')}</p>
              </button>
              {boothMode ? "" : 
                <button onClick={() =>{ setShowTab(4); setShowModal('profile'); }} className={`${activeTab === 4 ? 'selected':''}`}>
                    <div className="tab-bar-item">
                        <img
                            className="tab-bar-icon"
                            draggable="false"
                            src="/images/space/icon-more.png"
                        />
                    </div>
                    <p className={`text-xs ${activeTab === 4 ? 'text-white':'text-gray-400'}`}>{t('more')}</p>
                </button>
              }
          </div>
      </div>
    )
}
